import { render, staticRenderFns } from "./ControleDesmatamentoAmazoniaLista.vue?vue&type=template&id=ba3224b0&lang=pug"
import script from "./ControleDesmatamentoAmazoniaLista.vue?vue&type=script&lang=js"
export * from "./ControleDesmatamentoAmazoniaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports